export class ShouldElementBeDisplayed{
    displayForPickup:boolean;
    displayForDelivery:boolean;

    constructor(displayForPickup:boolean,displayForDelivery:boolean){
        this.displayForPickup   = displayForPickup;
        this.displayForDelivery = displayForDelivery;
    }

    //Creates an object determining that the element should be displayed both for pickup and delivery
    static generateDefaultDisplayOptions(){
        return new ShouldElementBeDisplayed(true,true);
    }
}